import React from "react";
import { MessageCircle } from "lucide-react";
import { BRAND } from "@/data/content";
import { useContent } from "@/context/ContentContext";

export const WhatsAppFloat = () => {
  const { content } = useContent();
  const number = (content.brand?.whatsappNumber || BRAND.whatsappNumber).replace(/\D/g, "");
  const msg = content.brand?.whatsappMessage || BRAND.whatsappMessage;
  const href = `https://wa.me/${number}?text=${encodeURIComponent(msg)}`;
  return (
    <a
      data-testid="whatsapp-float-btn"
      href={href}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-20 right-4 z-[60] flex h-14 w-14 items-center justify-center rounded-full border border-gold/40 bg-midnight/80 backdrop-blur-md shadow-[0_8px_30px_rgba(212,175,55,0.25)] transition hover:scale-110"
    >
      <span className="absolute inset-0 animate-ping rounded-full bg-gold/15" />
      <MessageCircle className="relative h-6 w-6 text-gold" strokeWidth={1.5} />
    </a>
  );
};

export default WhatsAppFloat;
